import type {
  AllocationValueTypeEnum,
  CareOrder,
  Counterparty,
  CptySettlementTypeEnum,
  Field,
  ISubaccount,
  NumericField,
  Security,
  SelectorField,
  SideEnum,
} from '@talos/kyoko';
import type { OMSReferenceDataState } from '../types';

export interface CareOrderFormDependencies {
  tradableSubAccounts: ISubaccount[];
}

export interface CareOrderState {
  // Difference between referenceData and dependencies is that referenceData is potentially needed to be available before first render, similar to ProvidersGate
  referenceData: OMSReferenceDataState;
  dependencies: CareOrderFormDependencies;

  form: CareOrderFormState;
  isLoading: boolean;
  initialized: boolean;
  careOrderBeingModified: CareOrder | undefined;
}

export interface CareOrderFormState {
  fundField: SelectorField<string>;
  symbolField: SelectorField<Security>;
  sideField: Field<SideEnum>;
  quantityField: NumericField;
  careOrderCurrencyField: SelectorField<CareOrderCurrency>;
  commentsField: Field;
  externalCommentsField: Field;
  initiatingFromField: Field;
  groupField: Field;
  externalIDField: Field;
  counterpartyField: SelectorField<Counterparty>;
  settleDateField: Field<string>;
  settleTypeField: Field<CptySettlementTypeEnum>;

  allocationValueTypeField: Field<AllocationValueTypeEnum>;
  allocations: { subAccountField: Field; valueField: NumericField }[];
}

/** string is for regular Base and Quote currencies, 0 is for Units */
export type CareOrderCurrency = string | 0;
/** The frontend-only way of specifying that the currency is in Unit space */
export const UNITS_CURRENCY = 0;
